// extracted by mini-css-extract-plugin
export default {"serviceTypes":"serviceTypes_serviceTypes__v0sW4"};